import { Component, Element, h, Prop, State } from '@stencil/core';
import { initShadowMountPoints } from '../../../utils/utils';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rtr-paypal-checkout',
  styleUrl: 'style.sass',
  shadow: true,
})

export class RtrPaypalCheckout {
  @Prop() amountToPay!: number;

  @Prop() onCreateOrder: () => Promise<string>;
  @Prop() onApproveOrder: (paymentId: string) => Promise<void>;
  @Prop() onClose: () => void;
  @State() isLoading: boolean = true;

  @Element() el: HTMLElement;

  componentDidLoad() {
    initShadowMountPoints(this.el, 'paypal-checkout');

    const paypalButtons = (window as any).paypal.Buttons({
      style: {
        shape: 'rect',
        layout: 'vertical',
        color: 'gold',
        label: 'paypal',
      },
      message: {
        amount: this.amountToPay,
      },
      createOrder: async () => {
        return await this.onCreateOrder();
      },
      onApprove: async (data) => {
        await this.onApproveOrder(data?.orderID)
      },
    });

    window.setTimeout(() => this.isLoading = false, 300);

    paypalButtons.render('#paypal-checkout-element');
  }

  disconnectedCallback() {
    const element = document.querySelector('#paypal-checkout-element');
    if (element) {
      // empty content is required to prevent duplicated buttons (happens when modal with button was closed and opened again)
      element.innerHTML = '';
    }
  }

  render() {
    return (
      <div class='overlay'>
        {this.isLoading &&
          <rentware-spinner withOverlay={true} />
        }
        <div style={{overflow: 'auto', width: '90%'}}>
          <slot name='paypal-checkout' />
        </div>
        <a
          class='cancel'
          href='#'
          onClick={(e) => {
            e.preventDefault();
            this.onClose();
          }}>
          {t('payment.changeMethod')}
        </a>
      </div>
    );
  }
}
